import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import StaticSearch from 'Features/StaticCategory/components/StaticSearch';
import { fetchPlatformLinux } from 'Redux/ducks/algolia-calls';
import globalMessages from 'Helpers/Messages/category-messages';

const messages = defineMessages({
  title: {
    id: 'linux.title',
    defaultMessage: 'Linux Games',
  },
  fullTitle: {
    id: 'linux.seotitle',
    defaultMessage: 'Linux Games | Latest Steam and Linux Games',
  },
  desc: {
    id: 'linux.seodesc',
    defaultMessage: 'Browse our selection of top games for Linux OSX, unbelievable value deals and exclusive steam game bundles. Fanatical is the official partner of over 975 game publishers and rated excellent on Trustpilot by our customers.',
  },
});

export default function PlatformLinux() {
  const { formatMessage } = useIntl();

  const crumbs = [
    {
      label: formatMessage(globalMessages.pcgames),
      link: '/all-games',
    },
    {
      label: formatMessage(messages.title),
      link: '/linux-games',
    },
  ];

  return (<StaticSearch
    showSortAndFilters
    updateHits={fetchPlatformLinux}
    url="linux-games"
    crumbs={crumbs}
    {...messages}
  />);
}
